import { createAcceptRepository } from './accept';
import { createCallRepository } from './call';
import { createInspectionRepository } from './inspection';
import { createMessageRepository } from './message';
import { createRealtimeSessionRepository } from './realtime-session';
import { createSessionRepository } from './session';
import { createStateRepository } from './state';
import { createThreadRepository } from './thread';
import { createTurnRepository } from './turn';
import { createWorkflowRepository } from './workflow';
export function createAssistantRepositories(config) {
    const repositoryConfig = {
        client: config.api,
        repository: config.kernel.repository,
    };
    return {
        realtimeSession: createRealtimeSessionRepository(repositoryConfig),
        thread: createThreadRepository(repositoryConfig),
        message: createMessageRepository(repositoryConfig),
        workflow: createWorkflowRepository(repositoryConfig),
        inspection: createInspectionRepository(repositoryConfig),
        state: createStateRepository(repositoryConfig),
        call: createCallRepository({
            config: {
                ...repositoryConfig,
                repository: {
                    ...repositoryConfig.repository,
                    thread: createThreadRepository(repositoryConfig),
                },
            },
        }),
        turn: createTurnRepository(repositoryConfig),
        session: createSessionRepository(repositoryConfig),
        accept: createAcceptRepository(repositoryConfig),
    };
}
//# sourceMappingURL=assistantProvider.js.map